import { useEffect, useState } from "react";
import { useAuthStore } from "@/features/auth/store/auth-store";
import { type FirmSettings, getFirmSettings } from "@/features/settings/firm-api";

interface UseFirmSettings {
  settings: FirmSettings | null;
  setSettings: (s: FirmSettings) => void;
  loading: boolean;
  error: boolean;
  isAdmin: boolean;
}

/**
 * Load the firm's extended settings once for a tab. Shared by the Invoices,
 * Client Portal and Defaults tabs — each PATCHes only its own slice, so they
 * refresh the shared row via `setSettings` after saving.
 */
export function useFirmSettings(): UseFirmSettings {
  const [settings, setSettings] = useState<FirmSettings | null>(null);
  const [error, setError] = useState(false);
  const isAdmin = useAuthStore((s) => s.user?.role === "country_director");

  useEffect(() => {
    let active = true;
    getFirmSettings()
      .then((s) => active && setSettings(s))
      .catch(() => active && setError(true));
    return () => {
      active = false;
    };
  }, []);

  return { settings, setSettings, loading: !settings && !error, error, isAdmin };
}
